const messages = {
    StockAdded: 'Added',
    StockRemoved: 'Removed',
    Surgery: 'Surgery',
    Cosmetology: 'Cosmetology',
    Dispatch: 'Dispatch',
    TpvSale: 'Sale',
    TpvSaleItemCancelled: 'Sale Cancelled',
    updateStock: 'Update Stock',
    transferStock: 'Transfer Stock',
    showRecords: 'Show Records',
    showInventoryByOffice: 'Show Inventory by Office',
    Attention: 'Attention',
    Notification: 'Notification',
    'Barcode lookup failed. Please try again or contact support.':
        'Barcode lookup failed. Please try again or contact support.',
    'Barcode Invalid. Please enter or scan it again.':
        'Barcode Invalid. Please enter or scan it again.',
    'Please enter or scan a barcode.': 'Please enter or scan a barcode.',
};

export default messages;
